import { EiAddStudent } from 'src/app/modules/ei-transition/models/ei-add-student.model';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';
import { normalizeOptionalText } from 'src/app/shared/functions/normalize-optional-text';

export class StudentSearchNewStudentRequest {
    lastName: string;
    middleName: string;
    firstName: string;
    gender: IReferenceData;
    dob: Date;
    homeBorough: IReferenceData;
    streetName: string;
    houseNumber: string;
    city: string;
    state: IReferenceData;
    zip: number;
    guardianRelationship: IReferenceData;
    guardianFirstName: string;
    guardianLastName: string;
    schoolDistrict: IReferenceData;
    apartmentNumber: string;
    studentSk: string;
    constructor(data?: EiAddStudent) {
        if (data) {
            const fullStreetAddress: string = data.childAddressStreet1?.trim() || '';
            const [firstPart, ...remainingParts]: string[] = fullStreetAddress.split(' ');
            const isStreetNumber: boolean = /^\d+[a-zA-Z0-9\-]*$/.test(firstPart || '');
            const parsedStreetNumber: string = isStreetNumber ? firstPart : '';
            const parsedStreetName: string = isStreetNumber
                ? remainingParts.join(' ').trim()
                : fullStreetAddress;

            this.lastName = normalizeOptionalText(data.childLastName);
            this.middleName = normalizeOptionalText(data.childMiddleName);
            this.firstName = normalizeOptionalText(data.childFirstName);

            // nothing for gender
            this.dob = data.dob;
            this.homeBorough = data.borough;
            this.streetName = normalizeOptionalText(parsedStreetName);
            this.houseNumber = normalizeOptionalText(parsedStreetNumber);
            this.apartmentNumber = normalizeOptionalText(data.childAddressStreet2);

            this.city = normalizeOptionalText(data.childAddressCity);
            this.state = data.childAddressState;

            this.zip = normalizeOptionalText(data.childAddressZip) as unknown as number;
            this.guardianRelationship = data.relationship;
            this.guardianFirstName = normalizeOptionalText(data.parentFirstName);
            this.guardianLastName = normalizeOptionalText(data.parentLastName);
            this.schoolDistrict = data.homeDistrict;
            this.studentSk = data?.studentSk;
        }
    }

    readonly id: string = '';
}